import React from "react";
import { Navigate } from "react-router-dom";
import { PATHS } from "../constants/paths";

/**
 * Route guard that only allows access if the user's role includes 'admin'.
 */
const AdminGuard = ({ children }) => {
  const token = localStorage.getItem("user_token");
  const userRole = localStorage.getItem("user_role");

  let hasAdmin = userRole === "admin";
  if (!hasAdmin && token) {
    try {
      const payload = JSON.parse(
        atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")),
      );
      const roles = [].concat(
        payload.role || [],
        payload.roles || [],
        payload.tokenRoles || [],
        payload.primaryRole || [],
      );
      hasAdmin = roles.includes("admin");
    } catch {
      hasAdmin = false;
    }
  }

  if (!token) {
    return <Navigate to={PATHS.LOGIN} replace />;
  }

  if (!hasAdmin) {
    return <Navigate to={PATHS.ROOT} replace />;
  }

  return children;
};

export default AdminGuard;
